import React from "react"
import { Box, Progress, Typography } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"

export function InsuranceCheckingStep(): JSX.Element {
  return (
    <Box role="status" sx={{ display: "flex", flexDirection: "column", inlineSize: "100%", minBlockSize: 416 }}>
      <Box
        sx={(theme) => ({
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(theme.tokens.spacing.sm)
        })}
      >
        <Typography variant="h3" component="h1">
          <FormattedMessage defaultMessage="Checking your coverage" />
        </Typography>
        <Typography>
          <FormattedMessage defaultMessage="This may take a moment." />
        </Typography>
      </Box>
      <Box sx={{ display: "flex", flex: 1, alignItems: "center", justifyContent: "center" }}>
        <Progress aria-hidden="true" size={36} sx={(theme) => ({ color: theme.palette.text.primary })} />
      </Box>
    </Box>
  )
}
